import { render } from "./BaseMessage.vue?vue&type=template&id=322d9f8d&scoped=true"
import script from "./BaseMessage.vue?vue&type=script&lang=js"
export * from "./BaseMessage.vue?vue&type=script&lang=js"

import "./BaseMessage.vue?vue&type=style&index=0&id=322d9f8d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-322d9f8d"
/* hot reload */
if (module.hot) {
  script.__hmrId = "322d9f8d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('322d9f8d', script)) {
    api.reload('322d9f8d', script)
  }
  
  module.hot.accept("./BaseMessage.vue?vue&type=template&id=322d9f8d&scoped=true", () => {
    api.rerender('322d9f8d', render)
  })

}

script.__file = "src/ui/tickets/messages/BaseMessage.vue"

export default script